// extracted by mini-css-extract-plugin
export default {"value":"CalculationSection_value__rpGNo","wrapper":"CalculationSection_wrapper__v0Oyn"};